import type { PublicApiKey } from '@/apilib';
import type { createTextEditorApi } from './textEditorApi';

export const TextEditorApiKey: PublicApiKey<typeof createTextEditorApi> = {
  name: 'TextEditorApi',
  public: true,
};
